export var GET_WIDGET_LIST_INIT = 'GET_WIDGET_LIST_INIT';
export var GET_WIDGET_LIST_SUCCESS = 'GET_WIDGET_LIST_SUCCESS';
export var GET_WIDGET_LIST_ERROR = 'GET_WIDGET_LIST_ERROR';
export var GET_WIDGET_LIST_DONE = 'GET_WIDGET_LIST_DONE';
export var GET_TEMPLATE_PUBLISHER_INIT = 'GET_TEMPLATE_PUBLISHER_INIT';
export var GET_TEMPLATE_PUBLISHER_SUCCES = 'GET_TEMPLATE_PUBLISHER_SUCCES';
export var GET_TEMPLATE_PUBLISHER_ERROR = 'GET_TEMPLATE_PUBLISHER_ERROR';
export var GET_TEMPLATE_PUBLISHER_DONE = 'GET_TEMPLATE_PUBLISHER_DONE';
export var GET_TEMPLATE_USER_INIT = 'GET_TEMPLATE_USER_INIT';
export var GET_TEMPLATE_USER_SUCCES = 'GET_TEMPLATE_USER_SUCCES';
export var GET_TEMPLATE_USER_ERROR = 'GET_TEMPLATE_USER_ERROR';
export var GET_TEMPLATE_USER_DONE = 'GET_TEMPLATE_USER_DONE';
export var UPDATE_TEMPLATE_INIT = 'UPDATE_TEMPLATE_INIT';
export var UPDATE_TEMPLATE_SUCCES = 'UPDATE_TEMPLATE_SUCCES';
export var UPDATE_TEMPLATE_ERROR = 'UPDATE_TEMPLATE_ERROR';
export var UPDATE_TEMPLATE_DONE = 'UPDATE_TEMPLATE_DONE';
export var UPDATE_USER_TEMPLATE_INIT = 'UPDATE_USER_TEMPLATE_INIT';
export var UPDATE_USER_TEMPLATE_SUCCES = 'UPDATE_USER_TEMPLATE_SUCCES';
export var UPDATE_USER_TEMPLATE_ERROR = 'UPDATE_USER_TEMPLATE_ERROR';
export var UPDATE_USER_TEMPLATE_DONE = 'UPDATE_USER_TEMPLATE_DONE';
export var GET_MEDIA_LIST_INIT = 'GET_MEDIA_LIST_INIT';
export var GET_MEDIA_LIST_SUCCESS = 'GET_MEDIA_LIST_SUCCESS';
export var GET_MEDIA_LIST_ERROR = 'GET_MEDIA_LIST_ERROR';
export var GET_MEDIA_LIST_DONE = 'GET_MEDIA_LIST_DONE';
export var GET_WIDGET_DETAILS_INIT = 'GET_WIDGET_DETAILS_INIT';
export var GET_WIDGET_DETAILS_SUCCESS = 'GET_WIDGET_DETAILS_SUCCESS';
export var GET_WIDGET_DETAILS_ERROR = 'GET_WIDGET_DETAILS_ERROR';
export var GET_WIDGET_DETAILS_DONE = 'GET_WIDGET_DETAILS_DONE';
export var GET_WIDGET_CALENDAR_INIT = 'GET_WIDGET_CALENDAR_INIT';
export var GET_WIDGET_CALENDAR_SUCCESS = 'GET_WIDGET_CALENDAR_SUCCESS';
export var GET_WIDGET_CALENDAR_ERROR = 'GET_WIDGET_CALENDAR_ERROR';
export var GET_WIDGET_CALENDAR_DONE = 'GET_WIDGET_CALENDAR_DONE';
export var GET_WIDGET_DATA_INIT = 'GET_WIDGET_DATA_INIT';
export var GET_WIDGET_DATA_SUCCESS = 'GET_WIDGET_DATA_SUCCESS';
export var GET_WIDGET_DATA_ERROR = 'GET_WIDGET_DATA_ERROR';
export var GET_WIDGET_DATA_DONE = 'GET_WIDGET_DATA_DONE';
export var LOADING_INTERVAL_WD_SUMARY = "LOADING_INTERVAL_WD_SUMARY";
export var LOADING_INTERVAL_WD_TOP3_RATE_INCREASE = "LOADING_INTERVAL_WD_TOP3_RATE_INCREASE";
export var LOADING_INTERVAL_WD_TOP3_RATE_DECREASE = "LOADING_INTERVAL_WD_TOP3_RATE_DECREASE";
